var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification"},[_c('transition-group',{staticClass:"notification__container",attrs:{"name":"fade","tag":"div"}},_vm._l((_vm.notifications),function(ref){
var text = ref.text;
var type = ref.type;
var onClickClose = ref.onClickClose;
var id = ref.id;
return _c('g-notification-item',{key:id,attrs:{"type":type,"text":text,"onClickClose":onClickClose,"onClickNotification":_vm.onClickNotifications},on:{"timeout":function($event){return _vm.onNotificationTimeout(id)}}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }